<div (click)="startDraw()" id="draw-polyline" class="esri-widget--button esri-widget esri-interactive" [ngClass]="{'js-btn-active': isShowed}" title="Обчислити відстань">
  <span class="esri-icon-polyline"></span>
</div>
